<template>
    <div>
        <el-table
                border
                :data="tableList"
                :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                        }">
            <el-table-column
                    prop="date"
                    type="index"
                    label="序号"
                    align="center"
                    width="50px">
                <template scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="maintype"
                    align="center"
                    label="信息大类">
            </el-table-column>
            <el-table-column
                    prop="licenseNo"
                    align="center"
                    label="主体代码">
            </el-table-column>
            <el-table-column
                    prop="entName"
                    label="主体名称"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="infotype"
                    align="center"
                    label="信息类型">
            </el-table-column>
            <el-table-column
                    prop="infosource"
                    label="数据来源"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="infostate"
                    align="center"
                    label="数据状态">
            </el-table-column>
            <el-table-column
                    prop="time"
                    label="登记时间"
                    align="center">
            </el-table-column>
            <el-table-column
                    label="操作"
                    align="center">
                <template scope="scope">
                    <p class="btn-operation" @click="goDownload(scope.row)"><span>下载信用详细报告</span></p>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import {mapState} from "vuex";
    export default {
        name: "credit-henan",
        data(){
            return {
                paramsId:'',
                tableList:[],
                currentPage: 1,
                pageSize: 10
            }
        },
        created() {
            this.getRouterQuery();
            this.querList();
        },
        activated() {
            this.getRouterQuery();
            this.querList();
        },
        methods: {
            getRouterQuery(){
                this.id = this.$route.params.changeId;
                this.dataId = this.$route.params.id;
            },
            // 获取数据
            querList() {
                this.$http.get('/tenderer/credithenan/getCreditDetail?id='+this.id,).then((res) => {
                    if(res.data){
                        this.tableList = res.data.data;
                        if(res.data.data && res.data.data.length > 0){
                            this.tableList.forEach((item,idnex)=>{
                                item.createTime = item.createTime ? item.createTime.replace(/-/g,'/') : '';
                                item.cancelTime = item.cancelTime ? item.cancelTime.replace(/-/g,'/') : '';
                            })
                        }
                    }
                })
            },
            // 下载信用详细报告
            goDownload(row){
                window.open (row.url)
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>